import React from "react";
import { Outlet } from "react-router-dom";
import TopLevelNav from "../topLevelNav";

const ReportingShell = () => {
  return (
    <div className="reporting-shell" style={{ width: "100%" }}>
      <TopLevelNav topOffset={44} />
      <Outlet />
    </div>
  );
};

export default ReportingShell;
